import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { HttpClient, HttpEventType } from "@angular/common/http";
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { forkJoin, Observable, of, Subscription } from "rxjs";
import {
  catchError,
  debounceTime,
  filter,
  finalize,
  map,
  switchMap,
  tap,
} from "rxjs/operators";
import { User } from "src/app/_models";
import { AccountService } from "src/app/_services";
import { InsumoService } from "src/app/_services/insumos.service";
import { InsumosFieldsService } from "src/app/_services/insumosFields.service";
import { UploadService } from "src/app/_services/upload.service";
import { environment } from "src/environments/environment";
import * as uuid from "uuid";
import { isHoliday } from "../../_helpers/saoPauloHolidays";
import { AttachmentModelInsumo, Insumo } from "../../_models/insumos";
import { CompetenceDatePipe } from "../../_pipes/competence-date.pipe";
import { DeliveryDatePipe } from "../../_pipes/deliveryDate.pipe";
import { FormService } from "src/app/_services/form.service";
import { TicketService } from "src/app/_services/ticket.service";
import { SecondResponsibleInputComponent } from "src/app/_components/second-responsible-input/second-responsible-input.component";

declare var $: any;

const SOLICITATION_ID = 2;
@Component({
  selector: "app-insumo-visualizer",
  templateUrl: "./insumo-visualizer.component.html",
  styleUrls: ["./insumo-visualizer.component.css"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  providers: [CompetenceDatePipe, DeliveryDatePipe],
})
export class InsumoVisualizerComponent implements OnInit {
  @ViewChild(SecondResponsibleInputComponent) secondResponsibleInput: SecondResponsibleInputComponent;
  insumoId: string | number;

  ticketsCorrecao: { [key: number]: any[] } = {};
  isLoadingTickets: { [key: number]: boolean } = {};

  private uploadSubscription: Subscription | undefined;
  isLoadingAnexo: boolean = false;
  anexoDownloadTicket: string = environment.apiUrl + "/download/anexo-ticket/";

  submitted = false;
  fields: any[] = [];
  isChecked = true;
  filesImport = [];

  insumoUpdate: FormGroup;
  anexoInsumo: FormGroup;
  formUpdate: FormGroup;
  formDeadLine: FormGroup;
  formDeadLineSon: FormGroup;
  formGroup: FormGroup;
  formValidators: FormGroup;
  formChangeVersion: FormGroup;
  formAddNumeroSd: FormGroup;

  areaOptions: string[] = [];

  tipoDeInsumoOptions: string[] = [];
  actualInsumoId: any;
  insumoVersionList: string[] = [];
  holydays: string[] = [];
  tempInsumoId: any;
  start = false;
  user: User;
  userToken: string;
  insumo: Insumo = {} as Insumo;
  segmentoOptions: string[] = [];
  publicoOptions: string[] = [];

  modalUpdateRef: MatDialogRef<any>;

  searchUserCtrl1 = new FormControl();
  searchUserCtrl2 = new FormControl();
  messageErrorUpload = "";
  errorMsg: string;
  filteredUsers1: any;
  filteredUsers2: any;
  filteredUsersFilter: any;
  isLoading = false;
  actualInsumoLength: number = 0;

  files = [];
  attachments: any[] = [];
  anexoDownload: string = environment.apiUrl + "/download/anexo-insumo/";
  anexoModelFileDownload: string =
    environment.apiUrl + "/download/anexo-model-file-insumo/";
  hasInsumoJustify = new FormControl();
  inativarJustify = new FormControl();
  pendingInativarId: number;
  uploadLoading: boolean = false;
  insumoCompetenceDate = moment();

  frequency = new FormControl();
  frequencyOptions: string[] = [];

  formData: MatTableDataSource<any>;
  dataSourceForDownload: MatTableDataSource<any>;
  dataSourceLength: number = 0;
  isLoadingResults: boolean = true;
  isDownloadProcess: boolean = false;

  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  validatorCtrl = new FormControl();
  filteredValidators: Observable<string[]>;
  validators: any[] = [];
  allValidators: any;

  simulation: boolean = false;
  isInsumoSon: boolean = false;
  deadlineValue: Date = moment().add(1, "days").toDate();
  isUtilDay: boolean = false;
  isLastDayUtil: boolean = false;
  isDayOnMonth: boolean = false;
  isForThisCompetence: boolean = false;

  simulationsDate: string[] = [];
  dataSourceSimulation: MatTableDataSource<SimulationsDeadLine>;
  insumoName: string[] = [];
  insumoCompetence: string[] = [];

  @ViewChild("validatorInput") validatorInput: ElementRef<HTMLInputElement>;

  @ViewChild("fileUpload", { static: false }) fileUpload: ElementRef;
  @ViewChild("fileUploadInsumo", { static: false })
  fileUploadInsumo: ElementRef;

  @ViewChild("closeModalAlterarResponsavel")
  closeModalAlterarResponsavel: ElementRef;
  @ViewChild("closeModalAlterarDeadLine")
  closeModalAlterarDeadLine: ElementRef;
  @ViewChild("closeModalAlterarDeadLineSon")
  closeModalAlterarDeadLineSon: ElementRef;

  @ViewChild("closeModalHasInsumos") closeModalHasInsumos: ElementRef;
  @ViewChild("closeInativarModal") closeInativarModal: ElementRef;
  @ViewChild("openInativarModal") openInativarModal: ElementRef;
  @ViewChild("closeConfirmarEncerrarInativar") closeConfirmarEncerrarInativar: ElementRef;
  @ViewChild("openConfirmarEncerrarInativar") openConfirmarEncerrarInativar: ElementRef;
  @ViewChild("closeFrequencyModal") closeFrequencyModal: ElementRef;
  @ViewChild("openModal") openModal: ElementRef;
  @ViewChild("closeModalExcluir") closeModalExcluir: ElementRef;
  @ViewChild("confirmUploadModal") confirmUploadModal: ElementRef;
  @ViewChild("closeModalEncerrar") closeModalEncerrar: ElementRef;
  @ViewChild("closeConfirmDoc") closeConfirmDoc: ElementRef;
  @ViewChild("encerradosNada") encerradosNada: ElementRef;
  @ViewChild("closeModalVersion") closeModalVersion: ElementRef;
  @ViewChild("exportModal") exportModal: ElementRef;
  @ViewChild("closeModalUpdateInsumo") closeModalUpdateInsumo: ElementRef;
  @ViewChild("errorModal") errorModal: ElementRef;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("closeModalConfirm") closeModalConfirm: ElementRef;
  @ViewChild("confirmed") confirmed: TemplateRef<any>;

  @ViewChild("blockedModal") blockedModal: ElementRef;
  blockedMessage: string = "";

  formsolicitation: any;
  element: any;
  ticketAnexo: any;
  ticketId: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private insumosService: InsumoService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private insumoService: InsumoService,
    private http: HttpClient,
    private uploadService: UploadService,
    private ticketService: TicketService,
    private insumoFieldService: InsumosFieldsService,
    private formService: FormService
  ) {
    this.user = this.accountService.userValue.user;
    this.userToken = this.accountService.userValue.token;
  }

  loadTicketsCorrecao(insumoId: number): void {
    if (this.ticketsCorrecao[insumoId]) {
      return;
    }
    if (this.isLoadingTickets[insumoId]) {
      return;
    }

    this.isLoadingTickets[insumoId] = true;

    this.insumosService.getTicketsCorrecao(insumoId).subscribe(
      (tickets) => {
        const ticketsAtivos = tickets
          ? tickets.filter((ticket) => ticket.statusEnum !== "CANCELADO")
          : [];
        if (ticketsAtivos && ticketsAtivos.length > 0) {
          const ultimoTicket = ticketsAtivos.reduce((maisRecente, atual) => {
            const parseDate = (str: string) => {
              const [datePart, timePart] = str.split(" - ");
              const [day, month, year] = datePart.split("/");
              return new Date(
                `${year}-${month}-${day}T${timePart}:00`
              ).getTime();
            };

            const dataMaisRecente = parseDate(maisRecente.createAt);
            const dataAtual = parseDate(atual.createAt);
            return dataAtual > dataMaisRecente ? atual : maisRecente;
          });

          this.ticketService.getTicketById(ultimoTicket.id).subscribe(
            (ultimoTicketCompleto: any) => {
              if (
                ultimoTicketCompleto.ticketAnexos &&
                ultimoTicketCompleto.ticketAnexos.length > 0
              ) {
                const ultimoAnexo =
                  ultimoTicketCompleto.ticketAnexos[
                    ultimoTicketCompleto.ticketAnexos.length - 1
                  ];
                this.ticketAnexo = ultimoAnexo;
                this.ticketId = ultimoTicket.id;
              } else {
                this.ticketAnexo = null;
                this.ticketId = null;
              }
            },
            (error) => {
              console.error(error);
            }
          );
        }

        this.ticketsCorrecao[insumoId] = ticketsAtivos;
        this.isLoadingTickets[insumoId] = false;
      },
      (error) => {
        this.ticketsCorrecao[insumoId] = [];
        this.isLoadingTickets[insumoId] = false;
      }
    );
  }

  viewTicketDetails(ticketId: number): void {
    this.router.navigate(["/ticket", ticketId]);
  }

  getTicketsCorrecaoByInsumo(insumoId: number): any[] {
    const tickets = this.ticketsCorrecao[insumoId] || [];
    return tickets.filter((ticket) => ticket.statusEnum !== "CANCELADO");
  }

  isLoadingTicketsForInsumo(insumoId: number): boolean {
    return this.isLoadingTickets[insumoId] || false;
  }

  toggleExpansion(element: any): void {
    if (this.expandedElement === element) {
      this.expandedElement = null;
    } else {
      this.expandedElement = element;
      this.loadTicketsCorrecao(element.id);
    }
  }

  getTicketsIdsFormatados(insumoId: number): string {
    const tickets = this.getTicketsCorrecaoByInsumo(insumoId);
    return tickets.map((t) => t.id).join(", ");
  }
  expandedElement: PeriodicElement;

  ngOnInit(): void {
    this.formChangeVersion = this.formBuilder.group({
      version: ["", Validators.required],
      justificativa: ["", Validators.required],
    });

    this.validatorCtrl.setValidators([Validators.required]);
    this.hasInsumoJustify.setValidators([Validators.required]);
    this.inativarJustify.setValidators([Validators.required]);
    this.frequency.setValidators([Validators.required]);
    this.getInsumoFields();
    this.getHolidays();

    this.formAddNumeroSd = this.formBuilder.group({
      numeroSd: ["", Validators.required],
    });

    this.anexoInsumo = this.formBuilder.group({
      justify: [
        "",
        [
          Validators.minLength(3),
          Validators.maxLength(300),
          Validators.required,
        ],
      ],
    });
    this.insumoUpdate = this.formBuilder.group({
      name: [],
      segment: [],
      publico: [],
      area: [],
      frequency: [],
      competence: [],
      deadline: [],
      observations: [],
      insumoType: [],
      docTypeCheckboxGroup: new FormGroup({
        docTypeCheck1: new FormControl(""),
        docTypeCheck2: new FormControl(""),
        docTypeCheck3: new FormControl(""),
        docTypeCheck4: new FormControl(""),
        docTypeCheck5: new FormControl(""),
      }),
      validators: [],
      insumoAmount: [],
    });

    this.formUpdate = this.formBuilder.group({
      responsibleUpload: ["", [Validators.required]],
      secondResponsibleUpload: [null],
      analysisUpload: ["", [Validators.required]],
      justify: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(300),
        ],
      ],
    });

    this.formDeadLine = this.formBuilder.group({
      deadline: [moment(), Validators.required],
      utilDay: [false],
      dayOnMonth: [true],
      lastDayUtil: [false],
      limitDate: [""],
      day: [""],
      month: [""],
      year: [""],
      justify: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(300),
        ],
      ],
    });

    this.formDeadLineSon = this.formBuilder.group({
      deadline: [moment(), Validators.required],
      utilDay: [false],
      dayOnMonth: [true],
      lastDayUtil: [false],
      limitDate: [""],
      day: [""],
      month: [""],
      year: [""],
      justify: [
        "",
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(300),
        ],
      ],
    });

    this.searchUserCtrl1.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredUsers1 = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.http
            .get(`${environment.apiUrl}/api/user/search?email=${value}`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        )
      )
      .subscribe((data) => {
        if (data == undefined) {
          this.errorMsg = data["Error"];
          this.filteredUsers1 = [];
        } else {
          this.errorMsg = "";
          this.filteredUsers1 = data;
        }
      });

    this.searchUserCtrl2.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredUsers2 = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.http
            .get(`${environment.apiUrl}/api/user/search?email=${value}`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        )
      )
      .subscribe((data) => {
        if (data == undefined) {
          this.errorMsg = data["Error"];
          this.filteredUsers2 = [];
        } else {
          this.errorMsg = "";
          this.filteredUsers2 = data;
        }
      });

    this.validatorCtrl.valueChanges
      .pipe(
        filter((value) => value?.length > 3),
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.allValidators = [];
          this.isLoading = true;
        }),
        switchMap((value) =>
          this.http
            .get(`${environment.apiUrl}/api/user/search?email=${value}`)
            .pipe(
              finalize(() => {
                this.isLoading = false;
              })
            )
        )
      )
      .subscribe((data) => {
        if (data == undefined) {
          this.errorMsg = data["Error"];
          this.allValidators = [];
        } else {
          this.errorMsg = "";
          this.allValidators = data;
        }
      });

    this.route.params.subscribe((params) => {
      this.insumoId = params["id"];
      this.getInsumoById(this.insumoId);
      this.getAttachmentModels(this.insumoId);
      this.getDeadLineActual(this.insumoId);

      this.loadTicketsCorrecao(+this.insumoId);
    });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();

    // Add our validator
    if (value) {
      this.validators.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.validatorCtrl.setValue(null);
  }

  remove(validator: string): void {
    const index = this.validators.indexOf(validator);

    if (index >= 0) {
      this.validators.splice(index, 1);
    }
  }

  onChangeLimitDate(index: number) {
    switch (index) {
      case 1:
        this.formDeadLine.get("dayOnMonth").setValue(true);
        this.formDeadLine.get("utilDay").setValue(false);
        break;
      case 2:
        this.formDeadLine.get("dayOnMonth").setValue(false);
        this.formDeadLine.get("utilDay").setValue(true);
        break;
      case 3:
        this.formDeadLine.get("limitDate").reset();
        if (this.formDeadLine.get("lastDayUtil").value == true) {
          this.formDeadLine.get("limitDate").disable();
        } else {
          this.formDeadLine.get("limitDate").enable();
        }
        break;
    }
  }

  onChangeLimitDateSon(index: number) {
    switch (index) {
      case 1:
        this.formDeadLineSon.get("dayOnMonth").setValue(true);
        this.formDeadLineSon.get("utilDay").setValue(false);
        this.isDayOnMonth = true;
        break;
      case 2:
        this.formDeadLineSon.get("dayOnMonth").setValue(false);
        this.formDeadLineSon.get("utilDay").setValue(true);
        this.isUtilDay = true;
        this.isDayOnMonth = false;
        break;
      case 3:
        this.formDeadLineSon.get("limitDate").reset();
        if (this.formDeadLineSon.get("lastDayUtil").value == true) {
          this.formDeadLineSon.get("limitDate").disable();
          this.isLastDayUtil = true;
          this.isDayOnMonth = false;
        } else {
          this.formDeadLineSon.get("limitDate").enable();
          this.isUtilDay = true;
          this.isLastDayUtil = false;
          this.isDayOnMonth = false;
        }
        break;
    }
  }

  setCompetenceFormValue($event: EventEmitterValue) {
    this.insumoUpdate.get("competence").setValue($event.competence);
  }

  populateInsumoUpdateModal() {
    this.insumoUpdate.get("name").setValue(this.insumo.name);
    this.insumoUpdate.get("segment").setValue(this.insumo.segment.trim());
    this.insumoUpdate.get("publico").setValue(this.insumo.publico.trim());
    this.insumoUpdate.get("area").setValue(this.insumo.area);
    this.insumoUpdate.get("frequency").setValue(this.insumo.frequency);
    this.insumoUpdate.get("observations").setValue(this.insumo.observations);
    this.insumoUpdate.get("insumoType").setValue(this.insumo.type);
    this.insumoUpdate.get("insumoAmount").setValue(this.insumo.insumoAmount);
    this.insumoUpdate
      .get("competence")
      .setValue(this.insumoCompetenceDate.toISOString());

    this.insumo.acceptedDocs.split(",").forEach((doc) => {
      if (doc === "todos") {
        this.insumoUpdate
          .get("docTypeCheckboxGroup")
          .get(`docTypeCheck5`)
          .setValue(true);
        this.insumoUpdate
          .get("docTypeCheckboxGroup")
          .get(`docTypeCheck4`)
          .setValue(true);
        this.insumoUpdate
          .get("docTypeCheckboxGroup")
          .get(`docTypeCheck3`)
          .setValue(true);
        this.insumoUpdate
          .get("docTypeCheckboxGroup")
          .get(`docTypeCheck2`)
          .setValue(true);
        this.insumoUpdate
          .get("docTypeCheckboxGroup")
          .get(`docTypeCheck1`)
          .setValue(true);
      } else {
        if (doc === ".xls") {
          this.insumoUpdate
            .get("docTypeCheckboxGroup")
            .get(`docTypeCheck1`)
            .setValue(true);
        } else if (doc === ".xlsx") {
          this.insumoUpdate
            .get("docTypeCheckboxGroup")
            .get(`docTypeCheck2`)
            .setValue(true);
        } else if (doc === ".csv") {
          this.insumoUpdate
            .get("docTypeCheckboxGroup")
            .get(`docTypeCheck3`)
            .setValue(true);
        } else if (doc === ".pdf") {
          this.insumoUpdate
            .get("docTypeCheckboxGroup")
            .get(`docTypeCheck4`)
            .setValue(true);
        }
      }
    });
  }

  getInsumosFieldsPeriodicidade() {
    this.insumoFieldService
      .getByType("PERIODICIDADE")
      .subscribe((data: any[]) => {
        const localeFrequencyOptions: string[] = [];

        data.forEach((freq) =>
          localeFrequencyOptions.push(freq.fieldDescription)
        );

        this.frequencyOptions = [
          ...new Set([...localeFrequencyOptions, ...this.frequencyOptions]),
        ].sort((a, b) => a.localeCompare(b, 'pt-BR'));
      });
  }

  updateFrequency() {
    const data = {
      frequency: this.frequency.value,
      ticketId: this.insumo.id,
      userId: this.user.id,
    };

    this.insumosService.updateFrequency(data).subscribe((data) => {
      this.frequency.reset();
      this.closeFrequencyModal.nativeElement.click();
      this.getInsumoById(this.insumo.id);
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.validators.push(event.option.value);
    this.validatorInput.nativeElement.value = "";
    this.validatorCtrl.setValue(null);
  }

  uploadAnexoInsumo(insumo: any) {
    this.insumo = insumo;
    this.actualInsumoLength = insumo.attachments.length;
  }

  selectInsumoVersion(insumo: any) {
    this.insumo = insumo;
    this.insumo["insumoAnexos"].forEach((element) => {
      this.insumoVersionList.push("v" + element.version);
    });

    return;
  }

  insumoAtraso(element) {
    const date = new Date().getTime();
    const deadline = new Date(element.deadline).getTime();

    if (date > deadline) {
      return true;
    }

    return false;
  }

  onReset() {
    this.getInsumoById(this.insumoId);
  }

  /** Usuário logado é o responsável principal ou o 2º responsável pelo insumo. */
  isResponsible(insumo): boolean {
    return (
      this.user.email === insumo?.responsible?.email ||
      this.user.email === insumo?.secondResponsible?.email
    );
  }

  editPermission(responsibleUser?: string) {
    if (
      (responsibleUser === this.user.email &&
        this.user.userType !== "OPERACAO_VIVO") ||
      this.user.userType == "EQUIPE_INTERNA" ||
      this.user.userType == "OPERACAO_BPO"
    ) {
      return false;
    }

    return true;
  }

  onChangeInsumoDeadline() {
    if (
      this.user.userType === "OPERACAO_BPO" &&
      this.user.profile === "ROLE_ADMIN" &&
      this.insumo.competenceStatus === "VIGENTE"
    ) {
      return false;
    }

    return true;
  }

  isOperador() {
    if (this.user.userType === "OPERACAO_VIVO") {
      return false;
    } else if (this.user.userType === "OPERADOR_VIVO_JURIDICO") {
      return false;
    } else if (this.user.userType === "OPERADOR_VIVO_AUDITORIA") {
      return false;
    } else {
      return true;
    }
  }

  get deadlineErrorMessage(): string {
    const form = this.isInsumoSon ? this.formDeadLine : this.formDeadLineSon;
    switch (form.get("deadline")?.errors?.invalid) {
      case "invalid":
        return "A data limite não pode ser uma data que já passou, por favor altere a data.";
      case "holiday":
        return "Insumos não podem ter data de entrega em feriados, por favor altere a data.";
      default:
        return "Insumos não podem ter data de entrega nos finais de semana, por favor altere a data.";
    }
  }

  onChangeInsumoSon() {
    const [from, to] = this.isInsumoSon
      ? [this.formDeadLine, this.formDeadLineSon]
      : [this.formDeadLineSon, this.formDeadLine];
    to.patchValue(from.getRawValue());
    if (from.get("limitDate").disabled) {
      to.get("limitDate").disable();
    } else {
      to.get("limitDate").enable();
    }

    this.isInsumoSon = !this.isInsumoSon;
    this.isForThisCompetence = !this.isForThisCompetence;
  }

  onSubmit(): void {
    if (
      this.insumo.competenceStatus === "ENCERRADO" &&
      !this.insumo.allowNewUpload
    ) {
      return;
    }
    this.submitted = true;
    let updateAnexosInsumoDto: any = {};
    this.uploadLoading = true;

    if (this.actualInsumoLength > 0) {
      if (this.anexoInsumo.invalid) {
        this.uploadLoading = false;
        return;
      }

      updateAnexosInsumoDto = {
        userId: this.user.id,
        anexos: this.attachments.map((att) => ({
          ...att,
          userUpload: null,
        })),
        justificativa: this.anexoInsumo.get("justify").value,
        insumoId: this.insumo.id,
      };
      this.insumosService.updateAnexos(updateAnexosInsumoDto).subscribe(() => {
        this.anexoInsumo.reset();
        this.attachments = [];
        this.files = [];
        this.closeConfirmDoc.nativeElement.click();
        this.uploadLoading = false;
        this.submitted = false;
        this.getInsumoById(this.insumo.id);
      });
    } else {
      updateAnexosInsumoDto = {
        userId: this.user.id,
        anexos: this.attachments.map((att) => ({
          ...att,
          userUpload: null,
        })),
        justificativa: "",
        insumoId: this.insumo.id,
      };

      this.insumosService.updateAnexos(updateAnexosInsumoDto).subscribe(() => {
        this.attachments = [];
        this.files = [];
        this.closeConfirmDoc.nativeElement.click();
        this.uploadLoading = false;
        this.submitted = false;
        this.getInsumoById(this.insumo.id);
      });
    }
  }

  get formUp(): { [key: string]: AbstractControl } {
    return this.formUpdate.controls;
  }

  desativarInsumo(insumoId: number) {
    if (this.insumo.status !== 'INATIVO') {
      this.pendingInativarId = insumoId;
      if (this.insumo.competenceStatus !== 'ENCERRADO') {
        this.openConfirmarEncerrarInativar.nativeElement.click();
      } else {
        this.openInativarModal.nativeElement.click();
      }
      return;
    }
    const insumoDto = {
      insumoId: +insumoId,
      userId: this.user.id,
    };
    this.insumosService.inativarInsumo(insumoDto).subscribe(() => {
      this.getInsumoById(this.insumo.id);
    });
  }

  prosseguirParaJustificativa() {
    this.closeConfirmarEncerrarInativar.nativeElement.click();
    setTimeout(() => this.openInativarModal.nativeElement.click(), 300);
  }

  confirmarInativacao() {
    const insumoDto = {
      insumoId: +this.pendingInativarId,
      userId: this.user.id,
      justificativa: this.inativarJustify.value,
    };
    this.insumosService.inativarInsumo(insumoDto).subscribe(() => {
      this.closeInativarModal.nativeElement.click();
      this.inativarJustify.reset();
      this.getInsumoById(this.insumo.id);
    });
  }

  getInativacaoJustificativa(): string | null {
    const entries = this.insumo.history?.filter(h => h.actionEnum === 'INATIVACAO');
    if (!entries?.length) return null;
    return entries[entries.length - 1].justify;
  }

  utilDaysFormat(insumo) {
    if (insumo.utilDays === "-1") {
      return "Último dia útil";
    } else if (/^d\d+$/.test(insumo.utilDays)) {
      const dayOfMonth = insumo.utilDays.slice(1);
      return `Todo dia ${dayOfMonth} do mês`;
    } else if (/^\d+d$/.test(insumo.utilDays)) {
      const dayOfMonth = insumo.utilDays.slice(0, -1);
      return `Todo dia ${dayOfMonth} do mês`;
    } else {
      return `Todo ${insumo.utilDays}° dia útil`;
    }
  }

  utilDaysFormatSon(insumo) {
    if (insumo.actualUtilDays === "-1") {
      return "Último dia útil";
    } else if (/^d\d+$/.test(insumo.actualUtilDays)) {
      const dayOfMonth = insumo.actualUtilDays.slice(1);
      return `Todo dia ${dayOfMonth} do mês`;
    } else if (/^\d+d$/.test(insumo.actualUtilDays)) {
      const dayOfMonth = insumo.actualUtilDays.slice(0, -1);
      return `Todo dia ${dayOfMonth} do mês`;
    } else {
      return `Todo ${insumo.actualUtilDays}° dia útil`;
    }
  }

  disableUploadButton(element: Insumo) {
    if (element.status === "INATIVO" || element.status === "ENCERRADO") {
      return true;
    }
    if (!element.hasInsumo) {
      return true;
    }
    if (element.allowNewUpload) {
      return false;
    }
    if (element.allowToUpload) {
      return false;
    } else {
      return true;
    }
  }
  validatorCheck(insumo) {
    const hasValidator = insumo.validators.some(
      (validator) => validator.email === this.user.email
    );
    return hasValidator;
  }

  getInsumoById(id) {
    this.isLoadingResults = true;
    this.insumosService.getInsumoById(id).subscribe((data: Insumo) => {
      this.insumo = data;
      this.actualInsumoLength = data.attachments.length;
      this.isLoadingResults = false;
      this.setDeadlineForInsumoChange();
      this.setDeadlineForInsumoSonChange();
      this.getInsumosFieldsPeriodicidade();
      this.setDefaultInsumoCompetenceDate();
      this.getDeadLineActual(this.insumo.id);
      this.formDeadLineSon.get("dayOnMonth").setValue(true);
      this.formDeadLine.get("dayOnMonth").setValue(true);
    });
  }

  setDeadlineForInsumoChange() {
    const persistedDeadLine = moment();

    const insumoDeadlineSplit = this.insumo.deadline.split("/");

    persistedDeadLine.date(Number(insumoDeadlineSplit[0]));
    persistedDeadLine.month(Number(insumoDeadlineSplit[1]) - 1);
    persistedDeadLine.year(Number(insumoDeadlineSplit[2]));

    this.formDeadLine.get("deadline").setValue(persistedDeadLine.toDate());
  }

  setDeadlineForInsumoSonChange() {
    const persistedDeadLine = moment();

    const insumoDeadlineSplit = this.insumo.actualDeadline.split("/");

    persistedDeadLine.date(Number(insumoDeadlineSplit[0]));
    persistedDeadLine.month(Number(insumoDeadlineSplit[1]) - 1);
    persistedDeadLine.year(Number(insumoDeadlineSplit[2]));

    this.formDeadLineSon.get("deadline").setValue(persistedDeadLine.toDate());
  }

  setDefaultInsumoCompetenceDate() {
    const month = Number(this.insumo.competence.split("/")[0]);
    const year = Number(this.insumo.competence.split("/")[1]);

    this.insumoCompetenceDate.date(1);
    this.insumoCompetenceDate.month(month - 1);
    this.insumoCompetenceDate.year(year);
    this.insumoCompetenceDate.hour(0);
    this.insumoCompetenceDate.minute(0);
    this.insumoCompetenceDate.second(0);
    this.insumoCompetenceDate.millisecond(0);
  }

  openHasInsumoModal(event) {
    if (!event.checked) {
      this.openModal.nativeElement.click();
    } else {
      this.changeHasInsumo();
    }
  }

  changeHasInsumo() {
    const hasInsumoDto = {
      value: this.insumo.hasInsumo,
      justify: this.hasInsumoJustify.value,
      insumoId: this.insumoId,
      userId: this.user.id,
    };

    this.insumosService.updateHasInsumo(hasInsumoDto).subscribe((res) => {
      this.getInsumoById(this.insumoId);
      this.closeModalHasInsumos.nativeElement.click();
      this.hasInsumoJustify.reset();
    });
  }

  changeAllowNewUpload() {
    const allowNewUploadDto = {
      value: this.insumo.allowNewUpload,
      insumoId: this.insumoId,
      userId: this.user.id,
    };

    this.insumosService
      .updateAllowNewUpload(allowNewUploadDto)
      .subscribe((res) => {
        this.getInsumoById(this.insumoId);
      });
  }

  excluirInsumo() {
    this.insumosService.deleteInsumo(this.tempInsumoId).subscribe((data) => {
      this.getInsumoById(this.insumo.id);
      this.tempInsumoId = null;
      this.closeModalExcluir.nativeElement.click();
    });
  }

  addNumeroSd() {
    const formAddNumeroSd = this.formAddNumeroSd.value;

    const insumoAddNumeroSdDto = {
      insumoId: this.actualInsumoId,
      userId: this.user.id,
      numeroSd: formAddNumeroSd.numeroSd,
    };

    this.insumosService
      .insumoAddNumeroSd(insumoAddNumeroSdDto)
      .subscribe(() => {
        location.reload();
      });
  }

  validationDeadLine(): boolean {
    // Dias úteis / Último dia útil: a data escolhida é só referência do mês; a data final
    // é calculada já em dia útil, então não se valida fim de semana/feriado nela
    if (this.formDeadLine.get("utilDay")?.value) {
      return true;
    }

    let deadline = this.formDeadLine.get("deadline").value;
    deadline = this.formatData(deadline);

    let isInvalid = false;

    this.holydays.forEach((element) => {
      if (element == deadline) {
        this.formDeadLine.get("deadline")?.setErrors({ invalid: "holiday" });
        isInvalid = true;
      }
    });

    if (new Date(deadline).getDay() == 5 || new Date(deadline).getDay() == 6) {
      this.formDeadLine.get("deadline")?.setErrors({ invalid: "notWorkDay" });
      isInvalid = true;
    }

    const day = deadline.split("-")[2];
    const month = deadline.split("-")[1];

    if (isHoliday(day, month)) {
      this.formDeadLine.get("deadline")?.setErrors({ invalid: "holiday" });
      isInvalid = true;
    }

    return !isInvalid;
  }

  validationDeadLineSon(): boolean {
    let deadline = this.formDeadLineSon.get("deadline").value;

    if (
      this.formDeadLineSon.get("day").value &&
      this.formDeadLineSon.get("month").value &&
      this.formDeadLineSon.get("year").value
    ) {
      const formattedDate = this.formatDateDeadLine(
        this.formDeadLineSon.get("day").value,
        this.formDeadLineSon.get("month").value,
        this.formDeadLineSon.get("year").value
      );
      deadline = moment(formattedDate, "DD/MM/YYYY").toDate();
    }

    // Dias úteis / Último dia útil: a data escolhida é só referência do mês; a data final
    // é calculada já em dia útil, então não se valida fim de semana/feriado nela
    if (this.formDeadLineSon.get("utilDay")?.value) {
      return true;
    }

    if (moment(deadline).isBefore(moment())) {
      this.formDeadLineSon.get("deadline")?.setErrors({ invalid: "invalid" });
      return false;
    }

    const formattedDeadline = moment(deadline).format("YYYY-MM-DD");
    let isInvalid = false;

    this.holydays.forEach((element) => {
      if (element === formattedDeadline) {
        this.formDeadLineSon.get("deadline")?.setErrors({ invalid: "holiday" });
        isInvalid = true;
      }
    });

    const dayOfWeek = moment(deadline).day();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      this.formDeadLineSon
        .get("deadline")
        ?.setErrors({ invalid: "notWorkDay" });
      isInvalid = true;
    }

    const day = moment(deadline).format("DD");
    const month = moment(deadline).format("MM");

    if (isHoliday(day, month)) {
      this.formDeadLineSon.get("deadline")?.setErrors({ invalid: "holiday" });
      isInvalid = true;
    }

    return !isInvalid;
  }

  formatData(date: any) {
    let timeStamp_date = new Date(date);
    let year = timeStamp_date.getFullYear();
    let month = formatZero(timeStamp_date.getMonth() + 1);
    let day = formatZero(timeStamp_date.getDate());

    function formatZero(numero) {
      return numero <= 9 ? "0" + numero : numero;
    }
    return `${year}-${month}-${day}`;
  }

  isClosing = false;

  encerrarInsumo() {
    if (this.isClosing) return;
    this.isClosing = true;
    const closeInsumoDto = {
      insumoId: this.tempInsumoId,
      userId: this.user.id,
    };
    this.insumosService.closeInsumo(closeInsumoDto).subscribe({
      next: () => {
        this.getInsumoById(this.insumo.id);
        this.tempInsumoId = null;
        this.isClosing = false;
        this.closeModalExcluir.nativeElement.click();
      },
      error: (err) => {
        this.isClosing = false;
        console.log('Erro ao encerrar insumo:', err);
        console.log('Status:', err.status);
        console.log('Error body:', err.error);
        this.closeModalExcluir.nativeElement.click();
        if (err.status === 409 && err.error?.message) {
          this.blockedMessage = err.error.message;
          // Aguardar o modal de confirmação fechar antes de abrir o modal de bloqueio
          setTimeout(() => {
            console.log('Tentando abrir modal blockedClose');
            const modalElement = document.getElementById('blockedClose');
            if (modalElement) {
              $(modalElement).modal('show');
            } else {
              console.error('Modal blockedClose não encontrado!');
              alert(this.blockedMessage);
            }
          }, 500);
        } else {
          console.log('Erro não tratado ou sem mensagem');
        }
      }
    });
  }

  getTooltipForInsumo(insumo) {
    if (insumo.insumoOrigin === 0) {
      insumo.insumoOrigin = insumo.id;
    }
    return `ID DO INSUMO ORIGEM: ${insumo.insumoRaiz}\nID DA ÚLTIMA COMPETÊNCIA: ${insumo.insumoOrigin}`;
  }

  onSubmitUpdate(): void {
    this.submitted = true;

    if (this.formUpdate.invalid) {
      return;
    }

    let tempAlterarResponsavel: any = {
      insumosId: this.actualInsumoId,
      responsibleUser: this.user.email,
      responsibleUpload: this.formUpdate.get("responsibleUpload").value,
      // null = não alterado (backend mantém o atual); "" = remover
      secondResponsibleUpload: this.formUpdate.get("secondResponsibleUpload").value,
      analysisUpload: this.formUpdate.get("analysisUpload").value,
      justify: this.formUpdate.get("justify").value,
    };

    this.submitted = false;
    this.formUpdate.get("secondResponsibleUpload").setValue(null);
    this.secondResponsibleInput?.reset();
    this.updatedInsumoResponsavel(tempAlterarResponsavel);
  }

  onSubmitDeadLine(): void {
    this.submitted = true;

    if (
      this.formDeadLine.get("day").value &&
      this.formDeadLine.get("month").value &&
      this.formDeadLine.get("year").value
    ) {
      const dia = this.formDeadLine.get("day").value;
      const mes = this.formDeadLine.get("month").value;
      const ano = this.formDeadLine.get("year").value;

      const formattedDate = this.formatDateDeadLine(dia, mes, ano);
      const dateObject = moment(formattedDate, "DD/MM/YYYY").toDate();
      this.formDeadLine.get("deadline").setValue(dateObject);
    }

    if (!this.validationDeadLine()) {
      this.showModalDeadlineError();
      return;
    }

    if (this.formDeadLine.invalid) {
      this.formDeadLine.markAllAsTouched();
      return;
    }

    const deadlineObj = this.validadeDatesForUtilDays();

    const tempAlterarDeadLine: any = {
      insumosId: this.actualInsumoId,
      responsibleUser: this.user.email,
      deadline: deadlineObj.deadline,
      utilDays: deadlineObj.utilDays,
      justify: this.formDeadLine.get("justify").value,
    };

    this.insumosService.updateDeadLine(tempAlterarDeadLine).subscribe(() => {
      this.closeModalAlterarDeadLine.nativeElement.click();
      this.formDeadLine.reset();
      this.formDeadLine.get("limitDate").enable();
      this.submitted = false;
      this.actualInsumoId = null;
      this.getInsumoById(this.insumo.id);
    });
  }

  showModalDeadlineError() {
    const modalElement = this.errorModal.nativeElement;
    ($(modalElement) as any).modal("show");
  }

  onSubmitDeadLineSon(): void {
    this.submitted = true;

    if (
      this.formDeadLineSon.get("day").value &&
      this.formDeadLineSon.get("month").value &&
      this.formDeadLineSon.get("year").value
    ) {
      const dia = this.formDeadLineSon.get("day").value;
      const mes = this.formDeadLineSon.get("month").value;
      const ano = this.formDeadLineSon.get("year").value;

      const formattedDate = this.formatDateDeadLine(dia, mes, ano);
      const dateObject = moment(formattedDate, "DD/MM/YYYY").toDate();
      this.formDeadLineSon.get("deadline").setValue(dateObject);
    }

    if (!this.validationDeadLineSon()) {
      this.showModalDeadlineError();
      return;
    }

    if (this.formDeadLineSon.invalid) {
      this.formDeadLineSon.markAllAsTouched();
      return;
    }

    const deadlineObj = this.validadeDatesForUtilDaysForSon();

    const tempAlterarDeadLine: any = {
      insumosId: this.actualInsumoId,
      responsibleUser: this.user.email,
      deadline: deadlineObj.deadline,
      utilDays: deadlineObj.utilDays,
      justify: this.formDeadLineSon.get("justify").value,
    };

    this.insumosService
      .updateDeadLineForActual(tempAlterarDeadLine)
      .subscribe(() => {
        this.closeModalAlterarDeadLine.nativeElement.click();
        this.simulation = false;
        this.formDeadLineSon.reset();
        this.formDeadLineSon.get("limitDate").enable();
        this.submitted = false;
        this.actualInsumoId = null;
        this.getInsumoById(this.insumo.id);
      });
  }

  formatDateDeadLine(day: string, month: string, year: string): string {
    const monthMap: Record<string, string> = {
      Janeiro: "01",
      Fevereiro: "02",
      Março: "03",
      Abril: "04",
      Maio: "05",
      Junho: "06",
      Julho: "07",
      Agosto: "08",
      Setembro: "09",
      Outubro: "10",
      Novembro: "11",
      Dezembro: "12",
    };

    const formattedDay = String(day).padStart(2, "0");
    const formattedMonth = monthMap[month];

    return `${formattedDay}/${formattedMonth}/${year}`;
  }

  openSimulation() {
    this.simulation = true;

    let deadlineDto = {
      day: "",
      competence: "",
    };

    if (this.formDeadLine.get("dayOnMonth").value) {
      const dia = this.formDeadLine.get("day").value;
      const mes = this.formDeadLine.get("month").value;
      const ano = this.formDeadLine.get("year").value;

      const formattedDate = this.formatDateDeadLine(dia, mes, ano);
      const date = moment(formattedDate, "DD/MM/YYYY").toDate();

      const comp =
        "0" + (date.getMonth() + 1).toString() + "/" + date.getFullYear();

      deadlineDto.day = "d" + dia;
      deadlineDto.competence = comp;
    } else if (this.formDeadLine.get("utilDay").value) {
      const date = moment(this.formDeadLine.get("deadline").value).toDate();
      const comp =
        "0" + (date.getMonth() + 1).toString() + "/" + date.getFullYear();

      deadlineDto.day = this.formDeadLine.get("limitDate").value;
      deadlineDto.competence = comp;
    } else if (this.formDeadLine.get("lastDayUtil").value) {
      const lastUtilDay = this.getLastUtilDay(
        moment(this.formDeadLine.get("deadline").value).toDate()
      );
      const date = moment(this.formDeadLine.get("deadline").value).toDate();
      const comp =
        "0" + (date.getMonth() + 1).toString() + "/" + date.getFullYear();

      deadlineDto.day = "-1";
      deadlineDto.competence = comp;
    }

    if (this.simulationsDate.length >= 3) {
      this.simulationsDate = [];
      this.insumoName = [];
      this.insumoCompetence = [];
    }

    this.insumoService
      .simulationDeadLine(this.insumo.id, deadlineDto)
      .subscribe((data) => {
        for (let i = 0; i < data.length; i++) {
          this.simulationsDate.push(
            moment(data[i].deadline).format("DD/MM/YYYY")
          );
          this.insumoName.push(data[i].nome);
          this.insumoCompetence.push(data[i].competence);
        }

        this.dataSourceSimulation = new MatTableDataSource<SimulationsDeadLine>(
          this.simulationsDate.map((date, i) => ({
            deadline: date.toString(),
            nome: this.insumoName[i] + " #" + (i + 1),
            competence: this.insumoCompetence[i],
          }))
        );

        if (this.isForThisCompetence) {
          this.dataSourceSimulation.data.splice(1, 2);
        }
      });
  }

  openSimulationSon() {
    this.simulation = true;

    let deadlineDto = {
      day: "",
      competence: "",
    };

    if (this.formDeadLineSon.get("dayOnMonth").value) {
      const dia = this.formDeadLineSon.get("day").value;
      const mes = this.formDeadLineSon.get("month").value;
      const ano = this.formDeadLineSon.get("year").value;

      const formattedDate = this.formatDateDeadLine(dia, mes, ano);
      const date = moment(formattedDate, "DD/MM/YYYY").toDate();

      const comp =
        "0" + (date.getMonth() + 1).toString() + "/" + date.getFullYear();

      deadlineDto.day = "d" + dia;
      deadlineDto.competence = comp;
    } else if (this.formDeadLineSon.get("utilDay").value) {
      const date = moment(this.formDeadLineSon.get("deadline").value).toDate();
      const comp =
        "0" + (date.getMonth() + 1).toString() + "/" + date.getFullYear();

      deadlineDto.day = this.formDeadLineSon.get("limitDate").value;
      deadlineDto.competence = comp;
    } else if (this.formDeadLineSon.get("lastDayUtil").value) {
      const lastUtilDay = this.getLastUtilDay(
        moment(this.formDeadLineSon.get("deadline").value).toDate()
      );
      const date = moment(this.formDeadLineSon.get("deadline").value).toDate();
      const comp =
        "0" + (date.getMonth() + 1).toString() + "/" + date.getFullYear();

      deadlineDto.day = "-1";
      deadlineDto.competence = comp;
    }

    if (this.simulationsDate.length >= 3) {
      this.simulationsDate = [];
      this.insumoName = [];
      this.insumoCompetence = [];
    }

    this.insumoService
      .simulationDeadLine(this.insumo.id, deadlineDto)
      .subscribe((data) => {
        for (let i = 0; i < data.length; i++) {
          this.simulationsDate.push(
            moment(data[i].deadline).format("DD/MM/YYYY")
          );
          this.insumoName.push(data[i].nome);
          this.insumoCompetence.push(data[i].competence);
        }

        this.dataSourceSimulation = new MatTableDataSource<SimulationsDeadLine>(
          this.simulationsDate.map((date, i) => ({
            deadline: date.toString(),
            nome: this.insumoName[i] + " #" + (i + 1),
            competence: this.insumoCompetence[i],
          }))
        );

        if (this.isForThisCompetence) {
          this.dataSourceSimulation.data.splice(1, 2);
        }
      });
  }

  validadeDatesForUtilDays() {
    let returnDate = {
      deadline: "",
      utilDays: "",
    };

    const date = {
      deadline: moment(this.formDeadLine.get("deadline").value),
      utilDay: this.formDeadLine.get("utilDay")?.value,
      lastDayUtil: this.formDeadLine.get("lastDayUtil")?.value,
      limitDate: this.formDeadLine.get("limitDate")?.value,
    };

    if (date.utilDay && date.lastDayUtil) {
      returnDate.utilDays = "-1";
      returnDate.deadline = this.getLastUtilDay(date.deadline.toDate());
    } else if (date.utilDay && !date.lastDayUtil) {
      returnDate.utilDays = date.limitDate;
      returnDate.deadline = this.getDateWithAddedDays(
        date.limitDate,
        date.deadline.toDate()
      );
    } else {
      returnDate.utilDays = "d" + date.deadline.date();
      returnDate.deadline = date.deadline.toISOString();
    }

    return returnDate;
  }

  validadeDatesForUtilDaysForSon() {
    let returnDate = {
      deadline: "",
      utilDays: "",
    };

    const date = {
      deadline: moment(this.formDeadLineSon.get("deadline").value),
      utilDay: this.formDeadLineSon.get("utilDay")?.value,
      lastDayUtil: this.formDeadLineSon.get("lastDayUtil")?.value,
      limitDate: this.formDeadLineSon.get("limitDate")?.value,
    };

    if (date.utilDay && date.lastDayUtil) {
      returnDate.utilDays = "-1";
      returnDate.deadline = moment(
        this.getLastUtilDay(date.deadline.toDate())
      ).format("YYYY-MM-DD");
    } else if (date.utilDay && !date.lastDayUtil) {
      returnDate.utilDays = date.limitDate;
      returnDate.deadline = moment(
        this.getDateWithAddedDays(date.limitDate, date.deadline.toDate())
      ).format("YYYY-MM-DD");
    } else {
      returnDate.utilDays = "d" + date.deadline.date();
      returnDate.deadline = date.deadline.format("YYYY-MM-DD");
    }

    return returnDate;
  }

  getDeadLineActual(insumoId) {
    this.insumoService.getInsumoById(insumoId).subscribe((data) => {
      let actualDeadLine = data.actualDeadline;
      const dia = parseInt(actualDeadLine.split("/")[0], 10);
      const mes = parseInt(actualDeadLine.split("/")[1], 10);
      const ano = actualDeadLine.split("/")[2];

      this.formDeadLineSon.get("day").setValue(this.days[dia - 1]);
      this.formDeadLineSon.get("month").setValue(this.months[mes - 1]);
      this.formDeadLineSon.get("year").setValue(ano);

      this.formDeadLine.get("day").setValue(this.days[dia - 1]);
      this.formDeadLine.get("month").setValue(this.months[mes - 1]);
      this.formDeadLine.get("year").setValue(ano);
    });
  }

  onSubmitConfig(): void {
    this.submitted = true;
    const tempAlterarInsumo: any = {
      insumoId: this.actualInsumoId,
      userId: this.user.id,
      name: this.insumoUpdate.get("name").value,
      segment: this.insumoUpdate.get("segment").value,
      publico: this.insumoUpdate.get("publico").value,
      competence: this.insumoUpdate.get("competence").value,
      area: this.insumoUpdate.get("area").value,
      insumoType: this.insumoUpdate.get("insumoType").value,
      observations: this.insumoUpdate.get("observations").value,
      acceptedDocs: this.acceptDocs(),
      insumoAmount: this.insumoUpdate.get("insumoAmount").value,
    };

    this.insumosService.updateInsumo(tempAlterarInsumo).subscribe(() => {
      this.submitted = false;
      this.actualInsumoId = null;
      this.insumoUpdate.reset();
      this.closeModalUpdateInsumo.nativeElement.click();
      this.getInsumoById(this.insumo.id);
    });
  }

  acceptDocs() {
    let docTypeString = "";

    if (this.insumoUpdate.get("docTypeCheckboxGroup.docTypeCheck5").value) {
      return "todos";
    }

    if (this.insumoUpdate.get("docTypeCheckboxGroup.docTypeCheck1").value) {
      docTypeString += ".xls,";
    }

    if (this.insumoUpdate.get("docTypeCheckboxGroup.docTypeCheck2").value) {
      docTypeString += ".xlsx,";
    }

    if (this.insumoUpdate.get("docTypeCheckboxGroup.docTypeCheck3").value) {
      docTypeString += ".csv,";
    }

    if (this.insumoUpdate.get("docTypeCheckboxGroup.docTypeCheck4").value) {
      docTypeString += ".pdf";
    }

    return docTypeString;
  }

  getInsumoFields() {
    forkJoin([
      this.getInsumosFieldsArea(),
      this.getInsumosFieldsSegmento(),
      this.getInsumosFieldsCadastroPublico(),
      this.getInsumosFieldsTipoDeInsumo(),
    ]).subscribe((resultados) => {
      const byDesc = (a: any, b: any) => (a.fieldDescription || '').localeCompare(b.fieldDescription || '', 'pt-BR');
      this.areaOptions = resultados[0].sort(byDesc);
      this.segmentoOptions = resultados[1].sort(byDesc);
      this.publicoOptions = resultados[2].sort(byDesc);
      this.tipoDeInsumoOptions = resultados[3].sort(byDesc);
    });
  }

  getInsumosFieldsArea() {
    return this.insumoFieldService.getByType("AREA");
  }

  getInsumosFieldsCadastroPublico() {
    return this.insumoFieldService.getByType("CADASTRO_PUBLICO");
  }

  getInsumosFieldsSegmento() {
    return this.insumoFieldService.getByType("SEGMENTO");
  }

  getInsumosFieldsTipoDeInsumo() {
    return this.insumoFieldService.getByType("TIPO_DE_INSUMO");
  }

  private isHolidayDate(date: moment.Moment): boolean {
    return this.holydays.some((h) => moment(h).isSame(date, "day"))
      || isHoliday(date.format("DD"), date.format("MM"));
  }

  getLastUtilDay(date: Date): string {
    let lastDay = moment(new Date(date.getFullYear(), date.getMonth() + 1, 0));
    let validate = true;

    while (validate) {
      // recua fins de semana e feriados (cadastrados + fixos de SP)
      if (lastDay.day() === 0 || lastDay.day() === 6 || this.isHolidayDate(lastDay)) {
        lastDay.subtract(1, "days");
      } else {
        validate = false;
      }
    }

    return lastDay.format("YYYY-MM-DD");
  }

  getDateWithAddedDays(days: number, date: Date): string {
    let index = days;
    let lastDay = moment(date);

    while (index > 0) {
      lastDay.add(1, "days");

      let isHoliday = false;
      this.holydays.forEach((element) => {
        const holidayDate = moment(element);
        if (holidayDate.isSame(lastDay, "day")) {
          isHoliday = true;
        }
      });

      if (lastDay.day() !== 0 && lastDay.day() !== 6 && !isHoliday) {
        index--;
      }
    }

    return lastDay.format("YYYY-MM-DD");
  }

  addValidators() {
    const insumoValidatorsDto = {
      insumoId: this.insumo.id,
      validators: this.validators,
      userId: this.user.id,
    };
    this.insumosService
      .updateValidators(insumoValidatorsDto)
      .subscribe(() => this.getInsumoById(this.insumo.id));
  }

  removeValidators(userEmail: string) {
    const insumoValidatorsDto = {
      insumoId: this.insumo.id,
      validators: [userEmail],
    };
    this.insumosService
      .removeValidators(insumoValidatorsDto)
      .subscribe(() => this.getInsumoById(this.insumo.id));
  }

  setEmailResponsibleUpload(user) {
    this.formUpdate.get("responsibleUpload").setValue(user.email);
  }

  setEmailAnalysisUpload(user) {
    this.formUpdate.get("analysisUpload").setValue(user.email);
  }

  resetField(form) {
    if (form === 1) {
      this.formUpdate.get("responsibleUpload").reset();
      this.searchUserCtrl1.reset();
    } else if (form === 2) {
      this.formUpdate.get("analysisUpload").reset();
      this.searchUserCtrl2.reset();
    } else if (form === 3) {
      this.formUpdate.get("analysisUpload").reset();
      this.searchUserCtrl2.reset();
      this.formUpdate.get("responsibleUpload").reset();
      this.searchUserCtrl1.reset();
    }
  }

  updatedInsumoResponsavel(insumoResponsavelDto) {
    this.insumosService
      .updateResponsavel(insumoResponsavelDto)
      .subscribe(() => {
        this.closeModalAlterarResponsavel.nativeElement.click();
        this.formUpdate.reset();
        this.resetField(3);
        this.actualInsumoId = null;
        this.getInsumoById(this.insumo.id);
      });
  }

  //uploads

  somArray = (list: any[]) => {
    let total = 0;
    list.map((item) => (total += item.progress));

    return total / list.length;
  };

  removeAnexoFormPreUpload(file: any) {
    this.anexos = this.anexos.filter(
      (item) => item.originalFileName !== file.originalFileName
    );
    this.arquivos = this.files.filter(
      (item) => item.data.name !== file.originalFileName
    );
  }

  removeFile(file: any) {
    this.attachments = this.attachments.filter(
      (item) => item.originalFileName !== file.originalFileName
    );
    this.files = this.files.filter(
      (item) => item.data.name !== file.originalFileName
    );
  }

  uploadFile(file) {
    const fileName = file.data.name;
    if (this.insumo.acceptedDocs) {
      if (this.insumo.acceptedDocs !== "todos") {
        const fileNameParts = fileName.split(".");
        const extension = `.${fileNameParts[fileNameParts.length - 1]}`;
        const acceptedDocs = this.insumo.acceptedDocs.split(",");
        if (!acceptedDocs.includes(extension)) {
          this.messageErrorUpload = `"${fileName}" extensão de arquivo incorreta. Verifique os tipos de arquivos permitidos no insumo cadastrado.`;
          this.uploadLoading = false;
          return;
        }
      }
    }
    if (file.data.size > 300000000) {
      this.messageErrorUpload = `O tamanho do arquivo ${fileName} é maior que o limite de 300MB.`;
      this.uploadLoading = false;
      return;
    }
    this.messageErrorUpload = "";
    const formData = new FormData();
    formData.append("file", file.data);
    file.inProgress = true;
    const fileBytes = file.data.size;

    this.isLoadingAnexo = true;
    this.uploadService.validationAws().subscribe((keys) => {
      const splitFileName = String(file.data.name).split(".");
      const mimeType = splitFileName[splitFileName.length - 1];
      const fileKey = uuid.v4();
      const fileName = String(file.data.name);

      this.uploadService
        .uploadFileInS3(file.data, fileKey, mimeType, keys)
        .on("httpUploadProgress", function (progress) {
          let progressPercentage = Math.round(
            (progress.loaded / progress.total) * 100
          );
          file.progress = progressPercentage;
        })
        .promise()
        .then(() => {
          this.uploadService
            .uploadInsumoAnexoS3(this.user.id, fileKey, fileName)
            .subscribe((body) => {
              this.attachments.push(body);
              this.isLoadingAnexo = false;
              this.uploadLoading = false;
            });
        })
        .catch((error) => {
          file.inProgress = false;
          this.uploadLoading = false;
          this.isLoadingAnexo = false;
          alert(`Erro ao anexar arquivo "${file.data.name}". Por favor, tente novamente.`);
          console.error('Erro no upload S3:', error);
        });
    });
  }

  private uploadFiles() {
    this.fileUpload.nativeElement.value = "";
    this.files.forEach((file) => {
      this.uploadFile(file);
    });
  }

  cancelarRequisicao(): void {
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
      this.isLoadingAnexo = false;
    }
  }

  onUploadButtonClick() {
    this.uploadLoading = true;
    this.files = [];
    const fileUpload = this.fileUpload.nativeElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({ data: file, inProgress: false, progress: 0 });
      }
      this.uploadFiles();
    };
    // fileUpload.click();
  }

  //uploads
  downloadFileNotification(fileId) {
    this.downloadFile(fileId);

    this.insumosService
      .downloadNotification(this.user.id, this.insumo.id, fileId)
      .subscribe(() => {
        console.log("Send notification");
      });
  }

  @ViewChild("anexoUpload", { static: false }) anexoUpload: ElementRef;
  @ViewChild("closeModalAnexoModel") closeModalAnexoModel: ElementRef;
  arquivos = [];
  anexos: any[] = [];
  dataSource = new MatTableDataSource<AttachmentModelInsumo>();

  onSubmitAnexoForm(): void {
    if (this.insumo.competenceStatus === "ENCERRADO") {
      return;
    }
    this.submitted = true;
    let updateModelFileAnexosDto: any = {};
    this.uploadLoading = true;

    updateModelFileAnexosDto = {
      userId: this.user.id,
      anexoModelFileInsumoList: this.anexos.map((att) => ({
        ...att,
        userUpload: null,
      })),
      insumoId: this.insumo.id,
    };

    this.insumoService
      .updateAnexosModelFile(updateModelFileAnexosDto)
      .subscribe(() => {
        this.arquivos = [];
        this.anexos = [];
        this.closeModalAnexoModel.nativeElement.click();
        this.uploadLoading = false;
        this.submitted = false;
        this.getInsumoById(this.insumo.id);
        this.getAttachmentModels(this.insumo.id);
      });
  }

  getAttachmentModels(insumoId) {
    this.insumoService.getInsumoById(insumoId).subscribe((data) => {
      this.dataSource = new MatTableDataSource<AttachmentModelInsumo>(
        data["attachmentsModel"] || []
      );
    });
  }

  downloadAnexoModel(fileId: any) {
    this.accountService.getTokenWithLowExpiration().subscribe((data) => {
      const urlToDownloadFile: string = `${this.anexoModelFileDownload}${fileId}?token=${data.token}`;

      window.open(urlToDownloadFile);
    });
  }

  downloadAnexoModelFileNotification(fileId) {
    this.downloadAnexoModel(fileId);

    this.insumosService
      .downloadAnexoModelFileNotification(this.user.id, this.insumo.id, fileId)
      .subscribe(() => {
        console.log("Send notification");
      });
  }

  formPermissions(): boolean {
    if (
      this.user.profile === "ROLE_ADMIN" ||
      this.user.userType === "OPERACAO_BPO"
    ) {
      return true;
    } else {
      return false;
    }
  }

  removeAnexoForm(anexoId) {
    let insumoRemoveAnexoModelDto = {
      insumoId: this.insumo.id,
      anexoModelId: anexoId,
      userId: this.user.id,
    };

    this.insumoService
      .removeAnexoModelFileInsumo(insumoRemoveAnexoModelDto)
      .subscribe((data) => {
        this.getInsumoById(this.insumo.id);
        this.getAttachmentModels(this.insumo.id);
        this.closeModalAnexoModel.nativeElement.click();
      });
  }

  onUploadAnexoButtonClick() {
    this.uploadLoading = true;
    this.arquivos = [];
    const anexoUpload = this.anexoUpload.nativeElement;
    anexoUpload.onchange = () => {
      for (let index = 0; index < anexoUpload.files.length; index++) {
        const file = anexoUpload.files[index];
        this.arquivos.push({ data: file, inProgress: false, progress: 0 });
      }
      this.uploadAnexosForm();
    };
  }

  uploadAnexoModelFileInsumo(insumo: any) {
    this.insumo = insumo;
    this.actualInsumoLength = insumo.attachmentsModel.length;
  }

  uploadAnexoForm(file) {
    const fileName = file.data.name;

    if (file.data.size > 300000000) {
      this.messageErrorUpload = `O tamanho do arquivo ${fileName} é maior que o limite de 300MB.`;
      this.uploadLoading = false;
      return;
    }
    this.messageErrorUpload = "";
    const formData = new FormData();
    formData.append("file", file.data);
    file.inProgress = true;

    this.isLoadingAnexo = true;

    this.uploadService
      .uploadAnexoInsumoModel(formData, this.user.id)
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              file.progress = Math.round((event.loaded * 100) / event.total);
              break;
            case HttpEventType.Response:
              return event;
          }
        }),
        catchError(() => {
          file.inProgress = false;
          this.uploadLoading = false;
          this.isLoadingAnexo = false;
          return of(`${file.data.name} upload failed.`);
        })
      )
      .subscribe((event: any) => {
        if (typeof event === "object") {
          this.anexos.push(event.body);
          this.isLoadingAnexo = false;
          this.uploadLoading = false;
        }
      });
  }

  private uploadAnexosForm() {
    this.anexoUpload.nativeElement.value = "";
    this.arquivos.forEach((file) => {
      this.uploadAnexoForm(file);
    });
  }

  removeAllAnexosForm() {
    this.insumoService
      .removeAllAnexoModelFileInsumo(this.insumo.id)
      .subscribe((data) => {
        this.getInsumoById(this.insumo.id);
        this.closeModalAnexoModel.nativeElement.click();
        this.getAttachmentModels(this.insumo.id);
      });
  }

  downloadFile(fileId: any) {
    this.accountService.getTokenWithLowExpiration().subscribe((data) => {
      const urlToDownloadFile: string = `${this.anexoDownload}${fileId}?token=${data.token}`;

      window.open(urlToDownloadFile);
    });
  }

  downloadTicketAnexo(anexoId: number, fileName: string): void {
    this.accountService.getTokenWithLowExpiration().subscribe((data) => {
      const urlToDownloadFile = `${this.anexoDownloadTicket}${anexoId}?token=${data.token}`;
      window.open(urlToDownloadFile);
    });
  }

  downloadFileInsumoContent(data: any) {
    const insumoVersion: number = Number(data.version.replace("v", ""));

    const file = data.insumoAnexos.find(
      (insumo) => insumo.version === insumoVersion
    );

    this.insumosService
      .downloadNotification(this.user.id, data.id, file.id)
      .subscribe(() => console.log("Send notification"));
    this.downloadFile(file.id);
  }

  changeVersion() {
    if (this.formChangeVersion.invalid) {
      return;
    }

    const insumoVersionDto = {
      insumosId: this.actualInsumoId,
      userId: this.user.id,
      version: this.formChangeVersion.get("version").value,
      justificativa: this.formChangeVersion.get("justificativa").value,
    };

    this.insumosService.updateVersion(insumoVersionDto).subscribe(() => {
      this.closeModalVersion.nativeElement.click();
      this.formChangeVersion.reset();
      this.actualInsumoId = null;
      this.getInsumoById(this.insumo.id);
    });
  }

  getInsumoWithVersion(insumoAnexos: any[], version: string) {
    return insumoAnexos.find((item) => item.version == version);
  }

  getHolidays() {
    this.http
      .get<
        any[]
      >(`https://date.nager.at/api/v3/PublicHolidays/${new Date().getFullYear()}/BR`)
      .subscribe((data) => {
        data.forEach((element) => {
          this.holydays.push(element.date);
        });
      });
  }

  columnsToDisplay = [
    "select",
    "name",
    "publico",
    "segment",
    "competence",
    "deadline",
    "version",
    "dataEntrega",
    "responsavel",
    "actions",
  ];

  displayedColumnsInterno: string[] = [
    "idArquivo",
    "nomeArquivo",
    "Justificativa",
    "dataEHoraEnvio",
    "versao",
    "acoes",
  ];

  displayedColumnsValidators: string[] = [
    "userName",
    "email",
    "userType",
    "acoes",
  ];

  displayedColumns: string[] = ["fileName", "inclusionDate", "download"];

  displayedColumnsSimulation: string[] = ["nome", "competencia", "deadline"];

  days: string[] = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

  months: string[] = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  years: string[] = Array.from({ length: 7 }, (_, i) => (i + 2024).toString());
}

interface EventEmitterValue {
  competence: string;
}

interface PeriodicElement {
  fileName: string;
  inclusionDate: string;
  download: string;
}

interface SimulationsDeadLine {
  deadline: string;
  nome: string;
  competence: string;
}
